import { Col, Row } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";

import Alert from "shared/components/Alert";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const Consents = ({
  setPercent,
  initialValues,
  errors,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });


  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CONSENTS}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.CONSENTS.TITLE}
      >
        <Row gutter={[16, 16]}>
          {/* Consentements : */}
          <Col lg={24} xs={24}>
            <Input
              type="switch"
              label={SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_CONTACT}
              defaultChecked={get(
                initialValues,
                "project.contact.acceptContact"
              )}
              errors={errors["project.contact.acceptContact"]}
              touched={
                !isEmpty(errors["project.contact.acceptContact"]) ||
                get(initialValues, "project.contact.acceptContact") === false
              }
              onChange={(value) => {
                set(
                  initialValues,
                  "project.contact.acceptContact",
                  value
                );
                setPercent(initialValues);
              }}
            />
          </Col>

          <Col lg={24} xs={24}>
            <Input
              type="switch"
              label={SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_MAIL_ME}
              defaultChecked={get(
                initialValues,
                "project.contact.acceptDigital"
              )}
              errors={errors["project.contact.acceptDigital"]}
              touched={
                !isEmpty(errors["project.contact.acceptDigital"]) ||
                get(initialValues, "project.contact.acceptDigital") === false
              }
              onChange={(value) => {
                set(
                  initialValues,
                  "project.contact.acceptDigital",
                  value
                );
                setPercent(initialValues);
              }}
            />
          </Col>

          <Col lg={24} xs={24}>
            <Alert
              showIcon
              type="info"
              message={SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_NOTE}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Consents;
